/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.title}} [{{Itemize.type | formatVar('LayoutTypes')}}]</li>
    <li class="w-50 list-item-col">{{Itemize.num_1}} 人</li>
    <!-- <li class="w-50 list-item-col flex-column align-items-start pl-4"> -->
    <li class="w-50 list-item-col">
      <label>&yen; {{Itemize.price_1}} 元/场(4小时)</label>
      <!-- <label>&yen; {{Itemize.price_1}} 元（上午）</label><label>&yen; {{Itemize.price_2}} 元（下午）</label>
      <label>&yen; {{Itemize.price_3}} 元（晚上）</label><label>&yen; {{Itemize.price_4}} 元（全天）</label> -->
    </li>
    <li class="w-50 list-item-col ">{{Itemize.high}} m²</li>
    <li class="w-50 list-item-col ">{{Itemize.area}} m²</li>
    <li class="w-50 list-item-col">{{Itemize.remark || '无'}}</li>
    <li class="w-50 list-item-col">已上传
      <span class="text-link" @click="showPic"> {{Itemize.pic ? Itemize.pic.split(',').length : 0}}</span> 张</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeMeet',
    props:{
      Itemize:{}
    },
    methods:{
      showPic() {
        if (!this.Itemize.pic) return;
        this._CarouselView({
          currentImg: 0,
          picArray: this.Itemize.pic.split(',')
        })
      }
    }
  }
</script>
